export default async function RestPropertiesService(data) {
  const endpoint = "/api/deployUrl";

  try {
    const res = await fetch(endpoint, {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    });
    return await res.clone().text();
  } catch (res_1) {
    return "false";
  }
}
